import axios from 'axios';
import { API_URL } from '../config/env';

const axiosInstance = axios.create({
  baseURL: API_URL,
});

axiosInstance.interceptors.request.use(function (config){
  config.headers["Accept-Language"] = localStorage.getItem("language")

  return config
})

export default axiosInstance
